module.exports = __webpack_public_path__ + "img/293.7409ef3c.svg";